<red-header-content>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="more"></ion-back-button>
    </ion-buttons>
    <ion-title>Personal Details</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="onSubmit()" [disabled]="!personalDetailsForm.valid || !personalDetailsForm.dirty"
        >Save<ion-icon slot="end" name="checkmark-circle-outline"></ion-icon
      ></ion-button>
    </ion-buttons>
  </ion-toolbar>
</red-header-content>
<red-page-content>
  <form [formGroup]="personalDetailsForm" (ngSubmit)="onSubmit()">
    <ion-list [inset]="true" lines="full" class="no-last-line">
      <ion-item-divider>
        <ion-label>Email</ion-label>
      </ion-item-divider>
      <ion-item>
        <ion-label color="primary">{{email$ | async}}</ion-label>
        <ion-icon color="primary" name="mail-outline" slot="start"></ion-icon>
      </ion-item>
    </ion-list>
    <ion-list [inset]="true" lines="full" class="no-last-line">
      <ion-item-divider color="primary">
        <ion-label>Details</ion-label>
      </ion-item-divider>
      <ion-item>
        <ion-input
          labelPlacement="stacked"
          placeholder="John"
          inputmode="text"
          [required]="true"
          type="text"
          formControlName="firstName"
        >
          <div slot="label">First Name: <ion-text color="danger">*</ion-text></div>
        </ion-input>
      </ion-item>
      <ion-item>
        <ion-input
          labelPlacement="stacked"
          placeholder="Doe"
          inputmode="text"
          [required]="true"
          type="text"
          formControlName="lastName"
        >
          <div slot="label">Last Name:<ion-text color="danger">*</ion-text></div></ion-input
        >
      </ion-item>
      <ion-item>
        <ion-input
          labelPlacement="stacked"
          placeholder="DEMO INC."
          inputmode="text"
          [required]="true"
          type="text"
          formControlName="company"
        >
          <div slot="label">Company Name:<ion-text color="danger">*</ion-text></div>
        </ion-input>
      </ion-item>
      <ion-item>
        <ion-input
          labelPlacement="stacked"
          placeholder="555-555-5555"
          inputmode="tel"
          [required]="true"
          type="text"
          formControlName="phone"
          [maskito]="phoneMask"
          [maskitoElement]="maskPredicate"
        >
          <div slot="label">Phone:<ion-text color="danger">*</ion-text></div>
        </ion-input>
      </ion-item>
    </ion-list>
    <ion-list [inset]="true" lines="full" class="no-last-line">
      <ion-item-divider>
        <ion-label>Actions</ion-label>
      </ion-item-divider>
      <ion-item (click)="deleteMyData()" [detail]="true">
        <ion-label color="danger">Delete My Data</ion-label>
        <ion-icon color="danger" name="trash-outline" slot="start"></ion-icon>
      </ion-item>
    </ion-list>
  </form>
</red-page-content>
